import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vibration-testing',
  templateUrl: './vibration-testing.component.html',
  styleUrls: ['./vibration-testing.component.css']
})
export class VibrationTestingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
